import { render, staticRenderFns } from "./UpgradeMode.vue?vue&type=template&id=5354115b&"
import script from "./UpgradeMode.vue?vue&type=script&lang=js&"
export * from "./UpgradeMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports